"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4067,3174],{

/***/ 71206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ testimonial; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 1 modules
var asset_component = __webpack_require__(49738);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonial/default-props.js
/* harmony default export */ var default_props = ({
    quote: {
        topic: {},
        title: '"Now that we have monday.com Work OS as the backbone of our organization I feel I have an overview I can trust."',
        body: null
    },
    author: "Charlie MacGregor, Founder & CEO",
    company: {
        title: "The Student Hotel"
    }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonial/testimonial.scss.js




var mdScreenSize = "".concat(vp_sizes.MD, "px");
var StylesTestimonial = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e17st2q80"
})("display:flex;padding-top:64px;padding-bottom:64px;justify-content:center;height:100%;width:100%;.content{display:flex;gap:45px;width:65%;justify-content:center;flex-direction:column;.quote{font-size:1.875rem;margin-bottom:50px;}.author{display:flex;align-items:center;gap:25px;font-size:1rem;.author-image{width:60px;}.company{font-weight:700;line-height:24px;font-size:1rem;}}}@media (max-width:", mdScreenSize, "){padding:32px 16px;.content{width:100%;gap:24px;line-height:1.5rem;.author-details-container{.author-name{font-size:0.75rem;}.company{font-size:0.75rem;}}.quote{margin-bottom:0;}}}&.white{color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}&.black{color:#000;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonial/testimonial.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}









var Testimonial = function(param) {
    var quote = param.quote, asset = param.asset, author = param.author, company = param.company, backgroundColor = param.backgroundColor;
    var additionalClassName = (0,react.useMemo)(function() {
        if (!backgroundColor) return;
        return (0,segments_service/* isDarkTheme */.$o)(backgroundColor) ? "white" : "black";
    }, [
        backgroundColor
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StylesTestimonial, {
        className: classnames_default()("testimonial", additionalClassName),
        style: {
            backgroundColor: colors/* default */.Z[backgroundColor]
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, _object_spread({
                    titleClassName: "quote"
                }, quote)),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "author",
                    children: [
                        (asset === null || asset === void 0 ? void 0 : asset.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                            image: asset,
                            className: "author-image"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "author-details-container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "author-name",
                                    children: author
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, _object_spread({
                                    titleClassName: "company"
                                }, company))
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var testimonial = (Testimonial);
Testimonial.defaultProps = default_props;


/***/ }),

/***/ 53174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ full_with_bullets_paragraph_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/default-props.js
var default_props = __webpack_require__(7484);
// EXTERNAL MODULE: ./segments/desktop/core-components/bullets/default-props.js
var bullets_default_props = __webpack_require__(96143);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-component.scss.js


var FULL_WITH_BULLETS_PARAGRAPH_WRAPPER_MAX_WIDTH = "1100px";
var StyledFullWithBulletsParagraphComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ujp7wo0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.full-with-bullets-paragraph-wrapper{margin:auto;display:flex;justify-content:center;padding:0px 32px;}");

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var FullWithBulletsParagraphComponent = function(props) {
    var maxWidth = props.maxWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFullWithBulletsParagraphComponent, {
        className: "full-with-bullets-paragraph-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "full-with-bullets-paragraph-wrapper",
            style: {
                maxWidth: maxWidth
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread({}, props))
        })
    });
};
FullWithBulletsParagraphComponent.defaultProps = _object_spread_props(_object_spread({}, default_props/* default */.Z), {
    bulletsConfig: bullets_default_props/* default */.Z,
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: sizes.MD,
    textSize: sizes.MD,
    maxWidth: FULL_WITH_BULLETS_PARAGRAPH_WRAPPER_MAX_WIDTH
});
/* harmony default export */ var full_with_bullets_paragraph_component = (FullWithBulletsParagraphComponent);


/***/ }),

/***/ 44067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ side_by_side_tabs_and_testimonial_tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs.js + 5 modules
var vertical_timer_tabs = __webpack_require__(34864);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./segments/desktop/core-components/testimonial/testimonial.js + 2 modules
var testimonial_testimonial = __webpack_require__(71206);
// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-component.js + 1 modules
var full_with_bullets_paragraph_component = __webpack_require__(53174);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-testimonial-tabs/side-by-side-tabs-and-testimonial-tabs-component.scss.js



var StyledSideBySideTabsAndTestimonialTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ed14x6u0"
})('.mobile-wrapper{.vertical-timer-tab-mobile-component{padding-bottom:32px;&:after{content:"";position:absolute;left:0;display:block;height:1px;width:100%;background-color:', colors/* default */.Z[color_consts.BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02], ";}.vertical-timer-tab-mobile-content-container{padding-bottom:20px;.testimonial{border-radius:8px;}}.vertical-timer-tab-mobile-title{padding-top:12px;gap:8px;padding-bottom:12px;.vertical-timer-tab-arrow-wrapper{display:flex;}}}}.tab-content{padding-right:32px;.full-with-bullets-paragraph-component{.full-with-bullets-paragraph-wrapper{padding:0;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-testimonial-tabs/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var TAB_CONTENT_DEFAULT_PROPS = {
    topic: {},
    title: null,
    bulletsConfig: null
};
/* harmony default export */ var default_props = ({
    maxLimit: 4,
    isFullScreen: true,
    showDivider: true,
    backgroundColor: "transparent",
    tabsTitle: {
        title: "A work solution that works the way you do"
    },
    tabs: [
        {
            title: "For leadership",
            content: _object_spread_props(_object_spread({}, TAB_CONTENT_DEFAULT_PROPS), {
                body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
            }),
            asset: {
                image: {
                    src: "/static/img/segment-layout-default-images/asset/timeline-view.png"
                }
            }
        },
        {
            title: "For managers",
            content: _object_spread_props(_object_spread({}, TAB_CONTENT_DEFAULT_PROPS), {
                body: "Gain greater visibility and transparency over the work being done with robust dashboards and project overviews of where initiatives stand."
            })
        },
        {
            title: "For teams and individuals",
            content: _object_spread_props(_object_spread({}, TAB_CONTENT_DEFAULT_PROPS), {
                body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
            }),
            asset: {
                image: {
                    src: "/static/img/segment-layout-default-images/asset/timeline-view.png"
                }
            }
        }
    ],
    timerEnabled: false,
    showButton: false,
    arrowSize: "12px",
    showArrow: true,
    assetPosition: images_grid_service/* positionTypes.CENTER_CENTER */.b.CENTER_CENTER,
    title: {
        fontSize: "24px",
        selectedFontSize: "24px"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-testimonial-tabs/side-by-side-tabs-and-testimonial-tabs-component.js
function side_by_side_tabs_and_testimonial_tabs_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_tabs_and_testimonial_tabs_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_tabs_and_testimonial_tabs_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_tabs_and_testimonial_tabs_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_tabs_and_testimonial_tabs_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_tabs_and_testimonial_tabs_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var SideBySideTabsAndTestimonialTabsComponent = function(_param) {
    var tabContent = _param.tabContent, title = _param.title, advancedTitleConfig = _param.advancedTitleConfig, prerenderTabs = _param.prerenderTabs, rest = _object_without_properties(_param, [
        "tabContent",
        "title",
        "advancedTitleConfig",
        "prerenderTabs"
    ]);
    var contentRenderer = function(contentObject) {
        var _contentObject_bulletsConfig_bullets, _contentObject_bulletsConfig;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tab-content",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_with_bullets_paragraph_component["default"], side_by_side_tabs_and_testimonial_tabs_component_object_spread_props(side_by_side_tabs_and_testimonial_tabs_component_object_spread(side_by_side_tabs_and_testimonial_tabs_component_object_spread_props(side_by_side_tabs_and_testimonial_tabs_component_object_spread({}, TAB_CONTENT_DEFAULT_PROPS, contentObject), {
                bulletsConfig: (contentObject === null || contentObject === void 0 ? void 0 : (_contentObject_bulletsConfig = contentObject.bulletsConfig) === null || _contentObject_bulletsConfig === void 0 ? void 0 : (_contentObject_bulletsConfig_bullets = _contentObject_bulletsConfig.bullets) === null || _contentObject_bulletsConfig_bullets === void 0 ? void 0 : _contentObject_bulletsConfig_bullets.length) ? contentObject.bulletsConfig : null
            }), tabContent), {
                titleSize: sizes.XS
            }))
        });
    };
    var testimonialRenderer = function(param) {
        var testimonial = param.testimonial;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(testimonial_testimonial/* default */.Z, side_by_side_tabs_and_testimonial_tabs_component_object_spread({}, testimonial));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideBySideTabsAndTestimonialTabsComponent, {
        className: "side-by-side-tabs-and-testimonial-tabs-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vertical_timer_tabs/* default */.Z, side_by_side_tabs_and_testimonial_tabs_component_object_spread_props(side_by_side_tabs_and_testimonial_tabs_component_object_spread({}, rest), {
            prerenderTabs: prerenderTabs,
            title: side_by_side_tabs_and_testimonial_tabs_component_object_spread({}, title, advancedTitleConfig),
            tabContentRenderer: contentRenderer,
            rightSideRenderer: testimonialRenderer
        }))
    });
};
SideBySideTabsAndTestimonialTabsComponent.defaultProps = default_props;
/* harmony default export */ var side_by_side_tabs_and_testimonial_tabs_component = (SideBySideTabsAndTestimonialTabsComponent);


/***/ })

}]);